import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import VersionPlayer from "@/components/creator/music/VersionPlayer";
import { fmtAgo } from "@/lib/studioApi";

const TUNE = { natural: "Tuned", tight: "Tight-tuned" };

/** Right-hand column: the AI original next to every version you've already made from it. */
export default function ReplaceSidebar({ project, version }) {
  const mine = (project.versions || []).filter((v) => v.kind === "my_vocal" && v.derived_from === version.id)
    .sort((a, b) => String(b.created_at).localeCompare(String(a.created_at))).slice(0, 5);
  const takeNo = (v) => v.touchups?.take_number || (project.takes || []).find((t) => t.id === v.take_id)?.take_number;
  return (
    <aside data-testid="replace-sidebar" className="space-y-5 rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/85 p-5 backdrop-blur-xl lg:sticky lg:top-36 lg:self-start">
      <div>
        <p className="mb-2 font-mono text-[10px] uppercase tracking-[0.18em] text-white/50">Original · AI lead</p>
        <VersionPlayer id={`side-original-${version.id}`} url={version.audio_url} duration={version.duration} />
      </div>
      <div>
        <p className="mb-2 font-mono text-[10px] uppercase tracking-[0.18em] text-amber-200/80">Your versions of this song</p>
        {mine.length ? (
          <ul className="space-y-4">
            {mine.map((v) => (
              <li key={v.id} data-testid={`replace-side-version-${v.id}`}>
                <p className="mb-1.5 flex flex-wrap items-center gap-1.5 text-[12px] text-white/70">
                  {takeNo(v) ? `Take ${takeNo(v)}` : "Your take"} · {fmtAgo(v.created_at)}
                  {TUNE[v.touchups?.tune] ? <span className="rounded-full border border-amber-300/40 px-1.5 py-px font-mono text-[9px] uppercase text-amber-200">{TUNE[v.touchups.tune]}</span> : null}
                  {v.touchups?.denoise ? <span className="rounded-full border border-sky-300/40 px-1.5 py-px font-mono text-[9px] uppercase text-sky-200">Cleaned</span> : null}
                </p>
                <VersionPlayer id={`side-${v.id}`} url={v.audio_url} duration={v.duration} />
              </li>
            ))}
          </ul>
        ) : <p data-testid="replace-side-empty" className="text-[12px] text-white/45">None yet — your first one will appear here, ready to compare with the original.</p>}
      </div>
      <Link to={`/create/project/${project.id}`} data-testid="replace-side-project" className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-white/50 hover:text-white">
        All versions in the project <ArrowRight className="h-3 w-3" />
      </Link>
    </aside>
  );
}
